import React, { useState } from "react";
import { FaPlus, FaTrash, FaChevronUp, FaChevronDown } from "react-icons/fa";

const Tab6Deployment = ({
  emergencyContactRecords,
  setEmergencyContactRecords,
  medicalFitnessRecords,
  setMedicalFitnessRecords,
  ppeSizes,
  setPpeSizes,
  declarationData,
  setDeclarationData,
  loading,
  addRecord,
  removeRecord,
  handleRecordChange,
  onSubmit,
  onSubmitDeployment,
  onSubmitDeclaration,
  setActiveTab,
}) => {
  const [expandedSections, setExpandedSections] = useState({
    emergencyContacts: true,
    medicalFitness: true,
    ppeSizes: true,
    declarations: true,
  });

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const formatPhoneInput = (value) => {
    // Remove all non-digit characters except +
    let cleaned = value.replace(/[^\d+]/g, "");

    // If it starts with 0, remove it and add +91
    if (cleaned.startsWith("0")) {
      cleaned = "+91" + cleaned.substring(1);
    }
    // If it doesn't start with +, add +91
    else if (cleaned.length > 0 && !cleaned.startsWith("+")) {
      cleaned = "+91" + cleaned;
    }

    return cleaned;
  };

  return (
    <div>
      {/* Section 19: Deployment Only */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("emergencyContacts")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">🚀</span>
              19. Deployment Only
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.emergencyContacts ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Deployment-only data. Add emergency contacts, medical fitness records,
            and a single PPE sizes record.
          </p>
        </div>

        {expandedSections.emergencyContacts && (
          <>
            {/* Emergency Contacts */}
            <div className="register-stage2-section register-stage2-section--subsection">
              <div className="register-stage2-section__header-row">
                <div>
                  <h4 className="register-stage2-section__subtitle">
                    Emergency contacts
                  </h4>
                  <p className="register-stage2-section__help-text">
                    Add one or more emergency contacts to be stored with your
                    deployment profile.
                  </p>
                </div>
              </div>

              {emergencyContactRecords.map((record, index) => (
                <div key={record.id} className="register-stage2-record-card">
                  <div className="register-stage2-record-card__header">
                    <h4 className="register-stage2-record-card__title">
                      Emergency contact #{index + 1}
                    </h4>
                    {emergencyContactRecords.length > 1 && (
                      <button
                        type="button"
                        className="register-stage2-record-card__remove"
                        onClick={() =>
                          removeRecord(setEmergencyContactRecords, index, () => ({
                            id: `emergency-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
                            full_name: "",
                            relationship: "",
                            phone: "",
                            email: "",
                            errors: {},
                          }))
                        }
                        disabled={loading}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </div>
                  <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Emergency Contact Name
                      </label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={record.full_name}
                        onChange={(e) =>
                          handleRecordChange(
                            setEmergencyContactRecords,
                            index,
                            "full_name",
                            e.target.value,
                          )
                        }
                        placeholder="Full name"
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Relationship
                      </label>
                      <input
                        type="text"
                        className="register-stage2-form__input"
                        value={record.relationship}
                        onChange={(e) =>
                          handleRecordChange(
                            setEmergencyContactRecords,
                            index,
                            "relationship",
                            e.target.value,
                          )
                        }
                        placeholder="Spouse, Parent, etc."
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Emergency Phone
                      </label>
                      <input
                        type="tel"
                        className="register-stage2-form__input"
                        value={record.phone}
                        onChange={(e) => {
                          const formatted = formatPhoneInput(e.target.value);
                          handleRecordChange(
                            setEmergencyContactRecords,
                            index,
                            "phone",
                            formatted,
                          );
                        }}
                        placeholder="+91 98765 43210"
                        disabled={loading}
                      />
                    </div>

                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Emergency Email
                      </label>
                      <input
                        type="email"
                        className="register-stage2-form__input"
                        value={record.email}
                        onChange={(e) =>
                          handleRecordChange(
                            setEmergencyContactRecords,
                            index,
                            "email",
                            e.target.value,
                          )
                        }
                        placeholder="emergency@example.com"
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="register-stage2-add-btn"
                onClick={() =>
                  addRecord(setEmergencyContactRecords, () => ({
                    id: `emergency-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
                    full_name: "",
                    relationship: "",
                    phone: "",
                    email: "",
                    errors: {},
                  }))
                }
                disabled={loading}
              >
                <FaPlus /> Add emergency contact
              </button>
            </div>

            {/* Medical Fitness Records - Subsection */}
            <div className="register-stage2-section register-stage2-section--subsection">
              <div
                className="register-stage2-section__header"
                onClick={() => toggleSection("medicalFitness")}
                style={{ cursor: "pointer" }}
              >
                <div className="register-stage2-section__header-top">
                  <h4 className="register-stage2-section__subtitle">
                    Medical fitness records
                  </h4>
                  <span className="register-stage2-section__chevron">
                    {expandedSections.medicalFitness ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </div>
                <p className="register-stage2-section__help-text">
                  Add one or more medical fitness records for deployment
                  screening.
                </p>
              </div>

              {expandedSections.medicalFitness && (
                <>
                  {medicalFitnessRecords.map((record, index) => (
                    <div key={record.id} className="register-stage2-record-card">
                      <div className="register-stage2-record-card__header">
                        <h4 className="register-stage2-record-card__title">
                          Medical fitness record #{index + 1}
                        </h4>
                        {medicalFitnessRecords.length > 1 && (
                          <button
                            type="button"
                            className="register-stage2-record-card__remove"
                            onClick={() =>
                              removeRecord(setMedicalFitnessRecords, index, () => ({
                                id: `medical-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
                                fitness_type: "",
                                provider: "",
                                status: "",
                                issue_date: "",
                                expiry_date: "",
                                restrictions: "",
                                errors: {},
                              }))
                            }
                            disabled={loading}
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                      <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Fitness Type
                          </label>
                          <select
                            className="register-stage2-form__select"
                            value={record.fitness_type}
                            onChange={(e) =>
                              handleRecordChange(
                                setMedicalFitnessRecords,
                                index,
                                "fitness_type",
                                e.target.value,
                              )
                            }
                            disabled={loading}
                          >
                            <option value="">Select fitness type</option>
                            <option value="routine">Routine medical fitness</option>
                            <option value="pre_deployment">
                              Pre-deployment medical
                            </option>
                            <option value="seafarer">Seafarer medical fitness</option>
                            <option value="other">Other</option>
                          </select>
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Provider
                          </label>
                          <input
                            type="text"
                            className="register-stage2-form__input"
                            value={record.provider}
                            onChange={(e) =>
                              handleRecordChange(
                                setMedicalFitnessRecords,
                                index,
                                "provider",
                                e.target.value,
                              )
                            }
                            placeholder="Clinic or authority"
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Medical Fitness Status
                          </label>
                          <select
                            className="register-stage2-form__select"
                            value={record.status}
                            onChange={(e) =>
                              handleRecordChange(
                                setMedicalFitnessRecords,
                                index,
                                "status",
                                e.target.value,
                              )
                            }
                            disabled={loading}
                          >
                            <option value="">Select status</option>
                            <option value="DRAFT">Draft</option>
                            <option value="ACTIVE">Active</option>
                            <option value="EXPIRED">Expired</option>
                            <option value="REVOKED">Revoked</option>
                            <option value="ARCHIVED">Archived</option>
                          </select>
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Issue Date
                          </label>
                          <input
                            type="date"
                            className="register-stage2-form__input"
                            value={record.issue_date}
                            onChange={(e) =>
                              handleRecordChange(
                                setMedicalFitnessRecords,
                                index,
                                "issue_date",
                                e.target.value,
                              )
                            }
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__field-group">
                          <label className="register-stage2-form__label">
                            Expiry Date
                          </label>
                          <input
                            type="date"
                            className="register-stage2-form__input"
                            value={record.expiry_date}
                            onChange={(e) =>
                              handleRecordChange(
                                setMedicalFitnessRecords,
                                index,
                                "expiry_date",
                                e.target.value,
                              )
                            }
                            disabled={loading}
                          />
                        </div>

                        <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                          <div className="register-stage2-form__field-group">
                            <label className="register-stage2-form__label">
                              Medical Notes
                            </label>
                            <textarea
                              className="register-stage2-form__textarea"
                              rows="2"
                              value={record.restrictions}
                              onChange={(e) =>
                                handleRecordChange(
                                  setMedicalFitnessRecords,
                                  index,
                                  "restrictions",
                                  e.target.value,
                                )
                              }
                              placeholder="Any relevant medical information or restrictions..."
                              disabled={loading}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button
                    type="button"
                    className="register-stage2-add-btn"
                    onClick={() =>
                      addRecord(setMedicalFitnessRecords, () => ({
                        id: `medical-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
                        fitness_type: "",
                        provider: "",
                        status: "",
                        issue_date: "",
                        expiry_date: "",
                        restrictions: "",
                        errors: {},
                      }))
                    }
                    disabled={loading}
                  >
                    <FaPlus /> Add medical fitness record
                  </button>
                </>
              )}
            </div>

            {/* PPE Sizes - Subsection */}
            <div className="register-stage2-section register-stage2-section--subsection">
              <div
                className="register-stage2-section__header"
                onClick={() => toggleSection("ppeSizes")}
                style={{ cursor: "pointer" }}
              >
                <div className="register-stage2-section__header-top">
                  <h4 className="register-stage2-section__subtitle">
                    PPE sizes — single record, never in CV
                  </h4>
                  <span className="register-stage2-section__chevron">
                    {expandedSections.ppeSizes ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                </div>
                <p className="register-stage2-section__help-text">
                  Enter your current PPE sizes for deployments only.
                </p>
              </div>

              {expandedSections.ppeSizes && (
                <div className="register-stage2-form__grid register-stage2-form__grid--4col">
                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Helmet Size
                    </label>
                    <select
                      className="register-stage2-form__select"
                      value={ppeSizes.helmet_size}
                      onChange={(e) =>
                        setPpeSizes((prev) => ({
                          ...prev,
                          helmet_size: e.target.value,
                        }))
                      }
                      disabled={loading}
                    >
                      <option value="">Select size</option>
                      <option value="s">Small</option>
                      <option value="m">Medium</option>
                      <option value="l">Large</option>
                      <option value="xl">Extra Large</option>
                    </select>
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Safety Boot Size
                    </label>
                    <input
                      type="text"
                      className="register-stage2-form__input"
                      value={ppeSizes.safety_boot_size}
                      onChange={(e) =>
                        setPpeSizes((prev) => ({
                          ...prev,
                          safety_boot_size: e.target.value,
                        }))
                      }
                      placeholder="e.g., UK 9, US 10"
                      disabled={loading}
                    />
                  </div>

                  <div className="register-stage2-form__field-group">
                    <label className="register-stage2-form__label">
                      Coverall Size
                    </label>
                    <select
                      className="register-stage2-form__select"
                      value={ppeSizes.coverall_size}
                      onChange={(e) =>
                        setPpeSizes((prev) => ({
                          ...prev,
                          coverall_size: e.target.value,
                        }))
                      }
                      disabled={loading}
                    >
                      <option value="">Select size</option>
                      <option value="s">Small</option>
                      <option value="m">Medium</option>
                      <option value="l">Large</option>
                      <option value="xl">Extra Large</option>
                      <option value="xxl">2X Large</option>
                    </select>
                  </div>

                  <div className="register-stage2-form__grid register-stage2-form__grid--1col">
                    <div className="register-stage2-form__field-group">
                      <label className="register-stage2-form__label">
                        Additional PPE Requirements
                      </label>
                      <textarea
                        className="register-stage2-form__textarea"
                        rows="2"
                        value={ppeSizes.additional_requirements}
                        onChange={(e) =>
                          setPpeSizes((prev) => ({
                            ...prev,
                            additional_requirements: e.target.value,
                          }))
                        }
                        placeholder="Any additional PPE requirements or specifications..."
                        disabled={loading}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="register-stage2-form__actions register-stage2-form__actions--inline">
              <button
                type="button"
                className="register-stage2-form__btn register-stage2-form__btn--primary"
                onClick={onSubmitDeployment}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit Deployment Details"}
              </button>
            </div>
          </>
        )}
      </div>

      {/* Declarations */}
      <div className="register-stage2-section">
        <div
          className="register-stage2-section__header"
          onClick={() => toggleSection("declarations")}
        >
          <div className="register-stage2-section__header-top">
            <h3 className="register-stage2-section__title">
              <span className="register-stage2-section__icon">📜</span>
              Declarations
            </h3>
            <span className="register-stage2-section__chevron">
              {expandedSections.declarations ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </div>
          <p className="register-stage2-section__subtitle">
            Legal declarations and confirmations.
          </p>
        </div>

        {expandedSections.declarations && (
          <>
            <div className="register-stage2-form__grid register-stage2-form__grid--1col">
              <div className="register-stage2-form__field-group">
                <label className="register-stage2-form__checkbox-label">
                  <input
                    type="checkbox"
                    checked={declarationData.accuracy}
                    onChange={(e) =>
                      setDeclarationData({
                        ...declarationData,
                        accuracy: e.target.checked,
                      })
                    }
                    disabled={loading}
                  />
                  I confirm that all information provided is accurate and complete
                </label>
              </div>

              <div className="register-stage2-form__field-group">
                <label className="register-stage2-form__checkbox-label">
                  <input
                    type="checkbox"
                    checked={declarationData.conflict_of_interest}
                    onChange={(e) =>
                      setDeclarationData({
                        ...declarationData,
                        conflict_of_interest: e.target.checked,
                      })
                    }
                    disabled={loading}
                  />
                  I declare no conflict of interest
                </label>
              </div>
            </div>
            <div className="register-stage2-form__actions register-stage2-form__actions--inline">
              <button
                type="button"
                className="register-stage2-form__btn register-stage2-form__btn--primary"
                onClick={onSubmitDeclaration}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit Declarations"}
              </button>
            </div>
          </>
        )}
      </div>

      {/* Navigation Buttons */}
      <div className="register-stage2-form__actions">
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--outline"
          onClick={() => setActiveTab(5)}
          disabled={loading}
        >
          ← Previous Tab
        </button>
        <button
          type="button"
          className="register-stage2-form__btn register-stage2-form__btn--primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Profile"}
        </button>
      </div>
    </div>
  );
};

export default Tab6Deployment;